import { render, staticRenderFns } from "./tabsTutorial.vue?vue&type=template&id=719ecba4&scoped=true&"
import script from "./tabsTutorial.vue?vue&type=script&lang=js&"
export * from "./tabsTutorial.vue?vue&type=script&lang=js&"
import style0 from "./tabsTutorial.vue?vue&type=style&index=0&id=719ecba4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719ecba4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VIcon,VTab,VTabs,VTabsSlider})
